import styled from 'styled-components'

export const Container = styled.div`
  position: fixed;
  top: 20px;
  padding: 15px;
  border-radius: 5px;
  margin: 10px;
  background-color: yellow;
`
